import { useCallback } from 'react';
import { usePeopleManagementApi } from 'infrastructure/api';

export const DEFAULT_SCREENING_INTERVIEW_LIMIT = 4;
export const DEFAULT_GENERAL_INTERVIEW_LIMIT = 2;
export const DEFAULT_TECHNICAL_INTERVIEW_LIMIT = 1;

type WorkerPreferencesDto = {
  workerAlias: string;
  technicalInterviewLimitPerDay: Nullable<number>;
  screeningInterviewLimitPerDay: Nullable<number>;
  generalInterviewLimitPerDay: Nullable<number>;
};
type SubmitWorkerPreferencesCommand = {
  technicalInterviewLimitPerDay: number;
  screeningInterviewLimitPerDay: number;
  generalInterviewLimitPerDay: number;
};

const RESOURCE_URL = '/preferences';

const getPreferencesUrl = (alias: string): string => `${RESOURCE_URL}/${alias}`;

const usePreferencesService = () => {
  const { sendGetRequest, sendPostRequest } = usePeopleManagementApi();

  const getPreferences = useCallback(
    async (alias: string): Promise<WorkerPreferencesDto> => {
      const response = await sendGetRequest(getPreferencesUrl(alias));

      return response.json();
    },
    [sendGetRequest],
  );

  const submitPreferences = useCallback(
    async (alias: string, command: SubmitWorkerPreferencesCommand): Promise<WorkerPreferencesDto> => {
      const response = await sendPostRequest(getPreferencesUrl(alias), command);

      return response.json();
    },
    [sendPostRequest],
  );

  return {
    getPreferences,
    submitPreferences,
  };
};

export default usePreferencesService;
